import { defer } from 'react-router-dom'

import { mercuryApi } from '$api'

/**
 * Loads the fresh `/user-session` payload the My Profile forms start from.
 * Fetched directly (rather than read from the app store) because the store's
 * `userDetails` is the AngularJS-mapped subset, which drops fields the page
 * needs (e.g. the phone number and login providers).
 */
export default async function loader() {
  return defer({
    data: mercuryApi.get('/user-session'),
  })
}
